import '../styles/field.css';

// TSS vite/01 — primitivo de campo de formulario. Promueve el patrón
// .perfil__field/__label/__input--error/__error (features/perfil) a common/
// porque los tres formularios de escritura del portal (fincas, receptoras,
// donadoras) lo reusan. Entidad-agnóstico: no sabe de fetching ni endpoints.
//
// Uso con input propio:
//   <Field label="Nombre" name="name" value={name} onChange={…} error={err} required />
// Uso con control custom (select, textarea, FarmSelect/RaceSelect) vía children:
//   <Field label="Finca" required error={err}><FarmSelect … /></Field>
// El `error` (string) se pinta bajo el control; cuando hay children, el propio
// control decide su borde --error (recibe el error como prop desde el form).
export default function Field({
    label,
    name,
    value,
    onChange,
    error,
    required = false,
    type = 'text',
    maxLength,
    placeholder,
    disabled = false,
    hint,
    children,
}) {
    return (
        <div className="field">
            {label && (
                <label className="field__label" htmlFor={name}>
                    {label}
                    {required && <span className="field__required" aria-hidden="true"> *</span>}
                </label>
            )}

            {children ?? (
                <input
                    id={name}
                    name={name}
                    className={`field__input ${error ? 'field__input--error' : ''}`}
                    type={type}
                    value={value ?? ''}
                    maxLength={maxLength}
                    placeholder={placeholder}
                    disabled={disabled}
                    onChange={onChange}
                />
            )}

            {hint && !error && <span className="field__hint">{hint}</span>}
            {error && <span className="field__error">{error}</span>}
        </div>
    );
}
